import { useT } from "@/i18n";
import { IconButton, IconCrown } from "@/ui";

export type SuperAdminModeButtonProps = {
  isActive: boolean;
  onPress: () => void;
};

export const SuperAdminModeButton = ({ isActive, onPress }: SuperAdminModeButtonProps) => {
  const t = useT();
  const label = t("general.globalSearch.superAdminScope");

  return (
    <IconButton
      icon={IconCrown}
      label={label}
      hideTooltip={false}
      size="lg"
      variant={isActive ? "primary" : "secondary"}
      color={isActive ? "brand" : "muted"}
      aria-pressed={isActive}
      className="shrink-0"
      onPress={onPress}
    />
  );
};
